import { Controller } from '@hotwired/stimulus';

import Tip from '@/modules/tip';

export default class extends Controller {
  static values = { delay: Array };

  connect() {
    this.tip = Tip.init(this.element, this.hasDelayValue ? { delay: this.delayValue } : {});
  }

  disconnect() {
    this.tip?.destroy();
  }
}
